import Header from "./partials/Header";
import Footer from "./partials/Footer";
import MobileVerticalServiceSlider from "./modules/MobileVerticalServiceSlider";
import TestimonialHome from "./modules/TestimonialHome";
import BannerAbout from "./modules/BannerAbout";
import CounterUp from "./modules/CounterUp";
import ListSlider from "./modules/ListSlider";
import Popup from "./modules/Popup";
import Tabs from "./modules/Tabs";
import CopyToClipboard from "./modules/CopyToClipboard";
import Departments from "./modules/Departments";
import Select2 from "./modules/Select2";
import Doctors from "./modules/Doctors";
import SingleDoctor from "./modules/SingleDoctor";
import Awards from "./modules/Awards";
import Equip from "./modules/Equip";
import Customers from "./modules/Customers";
import Topics from "./modules/Topics";
import Recruitments from "./modules/Recruitments";
import BookAppointmentForm from "./modules/BookAppointmentForm";
import ApplyJobForm from "./modules/ApplyJobForm";
import RegisterForConsultationForm from "./modules/RegisterForConsultationForm";
import Datepicker from "./modules/Datepicker";
import Toggle from "./modules/Toggle";
import Accordion from "./modules/Accordion";
import Search from "./modules/Search";
import TraCuuForm from "./modules/TraCuuForm";
import Mascost from "./modules/Mascost";

new Header().init();
new Footer().init();
new ListSlider().init();
new MobileVerticalServiceSlider().init();
new TestimonialHome().init();
new BannerAbout().init();
new CounterUp().init();
new Popup().init();
new Tabs().init();
new CopyToClipboard().init();
new Departments().init();
new Select2().init();
new Doctors().init();
new SingleDoctor().init();
new Awards().init();
new Equip().init();
new Customers().init();
new Topics().init();
new Recruitments().init();
new BookAppointmentForm().init();
new Datepicker().init();
new ApplyJobForm().init();
new RegisterForConsultationForm().init();
new Datepicker().init();
new Toggle().init();
new Accordion().init();
new Search().init();
new TraCuuForm().init();
new Mascost().init();